import { formatMoney } from "@/utils/billingFormat";

export const getApiData = (response) =>
  response?.data?.data || response?.data?.Data || response?.data || null;

export const getApiMessage = (error, fallback = "Something went wrong.") =>
  error?.response?.data?.message ||
  error?.response?.data?.Message ||
  error?.response?.data?.title ||
  error?.message ||
  fallback;

export const read = (item, camel, pascal, fallback = undefined) =>
  item?.[camel] ?? item?.[pascal] ?? fallback;

export const formatGuestDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat("en-GB").format(date);
};

export const formatGuestDateTime = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
};

const splitEnum = (value) =>
  String(value ?? "—")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/_/g, " ");

export const formatTransactionType = (value) => {
  const map = {
    1: "Earned",
    2: "Redeemed",
    3: "Expired",
    4: "Adjusted",
    5: "Reversed",
    Earn: "Earned",
    Redeem: "Redeemed",
    Expire: "Expired",
    Adjust: "Adjusted",
    Reverse: "Reversed",
  };
  return map[value] || splitEnum(value);
};

export const formatCouponStatus = (value) => {
  const map = {
    1: "Active",
    2: "Used",
    3: "Expired",
    4: "Cancelled",
  };
  return map[value] || splitEnum(value);
};

export const formatMembershipStatus = (value) => {
  const map = {
    1: "Active",
    2: "Expired",
    3: "Cancelled",
    4: "Fully used",
    5: "Partially used",
    FullyUsed: "Fully used",
    PartiallyUsed: "Partially used",
  };
  return map[value] || splitEnum(value);
};

export { formatMoney };
